import React, { memo } from 'react';

import Box from '../Box/Box';
import { TPageElement } from './types/TPage';

const PageElement = ({ as = 'div', children, kind, ...rest }: TPageElement) => {
  return (
    <Box {...rest} parent="Page" name="element" as={as} modifiers={kind}>
      {children}
    </Box>
  );
};

export default memo(PageElement);
